import React from "react";
import { IntlShape, Consumer } from "./Context";

type WithIntlProps<P> = Omit<P, "intl">;

export default function withIntl<P extends object>(
    WrappedComponent: React.ComponentType<P & { intl: IntlShape }>
): React.FC<WithIntlProps<P>> {
    return (props: WithIntlProps<P>) => (
        <Consumer>{(intl) => <WrappedComponent {...(props as P)} intl={intl} />}</Consumer>
    );
}
